import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ChartLegendItem, PersonLegend } from 'src/app/models/report/person-legend.model';
import { ReportOptions } from 'src/app/models/report/report-options.model';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss']
})
export class SubHeaderComponent implements OnInit {
  
  @Input()
  public headerRatio21 = false;

  @Input()
  showLegend = false;

  @Input()
  showLegendIcon = true;
  
  @Input() 
  legend: PersonLegend[] | ChartLegendItem[] = [];

  @Input()
  reportOptions: ReportOptions;

  public get gaugeOptions() {
    return this.reportOptions.gaugeOptions;
  }
  
  currentDate: Date = new Date();

  constructor() { }

  ngOnInit(): void {
  }

  public resizeGauge() {
    const width = window.innerWidth;
          
    if (width < 1100 && width >= 600)  
      this.gaugeOptions.size = 62;
    else if (width < 600)
      this.gaugeOptions.size = 52;
    else
      this.gaugeOptions.size = 82;
  }

}
